import React from 'react';
import isReact from '../../is-react';
import styles from './QuickSelect.module.css';
import Tooltip from '@ls/react-tooltip';

const getSymbolicDesc = (symbolicDate) => {
  switch (symbolicDate) {
    case 'CBD':
      return 'Current Business Date';

    case 'PBD':
      return 'Previous Business Date';

    case 'PME':
      return 'Previous Month End';

    case 'PQE':
      return 'Previous Quarter End';

    case 'PYE':
      return 'Previous Year End';

    default:
      return symbolicDate;
  }
};

const QuickBtn = ({qBtn, onSelectDate, dpRef, disabled, onChangeSymbolicDate}) => {
  if (isReact.component(qBtn)) {
    return <qBtn/>;
  }
  if (isReact.element(qBtn)) {
    return qBtn;
  }
  if (typeof qBtn === 'object') {
    const {disabled, tooltip, date, label, style} = qBtn;
    let className = [styles.qsButton];
    if (disabled) {
      className.push(styles.qsButtonDisabled);
    }
    const onClick = () => {
      if (!disabled) {
        onSelectDate(date);
        dpRef?.current?.setOpen(false);
      }
    };
    return (
      <Tooltip
        render={tooltip}
        placement="bottom"
        distance={15}
      >
        <div style={style} className={className.join(' ')} onClick={onClick}>{label}</div>
      </Tooltip>
    );
  }
  if (typeof qBtn === 'string') {  //symbolic date
    const onClick = async () => {
      if (!disabled) {
        onChangeSymbolicDate(qBtn);
        dpRef?.current?.setOpen(false);
      }
    };
    return (
      <Tooltip
        render={getSymbolicDesc(qBtn)}
        placement="bottom"
        distance={15}
      >
        <div className={styles.qsButton} onClick={onClick}>{qBtn}</div>
      </Tooltip>
    );
  }
};

const QuickSelectBar = ({quickSelectButtons, onSelectDate, dpRef, onChangeSymbolicDate}) => {
  return (
    <div className={styles.qsRoot}>
      <div className={styles.qsButtons}>
        {quickSelectButtons.map((qBtn) => (
          <QuickBtn
            key={JSON.stringify(qBtn)}
            qBtn={qBtn}
            onSelectDate={onSelectDate}
            dpRef={dpRef}
            onChangeSymbolicDate={onChangeSymbolicDate}
          />
        ))}
      </div>
    </div>
  );
};

export default QuickSelectBar;
